function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { View } from 'react-native';
import { Text as PaperText, Checkbox as PaperCheckbox } from 'react-native-paper';
import { useHasError } from "../../hooks/useHasError.js";
import { Container } from "../Container/index.js";
export let Checkbox = (_ref) => {
  let {
    showErrorOnMount,
    input: {
      onChange,
      value
    },
    meta,
    label,
    labelPosition,
    getHelperText,
    ContainerProps,
    InnerContainerProps,
    LabelProps,
    HelperTextProps
  } = _ref,
      CheckboxProps = _objectWithoutProperties(_ref, ["showErrorOnMount", "input", "meta", "label", "labelPosition", "getHelperText", "ContainerProps", "InnerContainerProps", "LabelProps", "HelperTextProps"]);

  let error = useHasError(meta, showErrorOnMount);
  let helperText = getHelperText(error && meta.error);
  return /*#__PURE__*/React.createElement(Container, _extends({}, ContainerProps, {
    HelperTextProps: _objectSpread(_objectSpread({}, HelperTextProps), {}, {
      children: helperText,
      visible: !!helperText,
      type: error ? 'error' : 'info'
    })
  }), /*#__PURE__*/React.createElement(View, InnerContainerProps, labelPosition === 'left' && /*#__PURE__*/React.createElement(PaperText, LabelProps, label), /*#__PURE__*/React.createElement(PaperCheckbox, _extends({}, CheckboxProps, {
    onPress: () => onChange(!value),
    status: value ? 'checked' : 'unchecked'
  })), labelPosition === 'right' && /*#__PURE__*/React.createElement(PaperText, LabelProps, label)));
};
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  showErrorOnMount: false,
  getHelperText: str => str,
  labelPosition: 'right',
  InnerContainerProps: {},
  LabelProps: {},
  ContainerProps: {},
  HelperTextProps: {
    padding: 'normal'
  }
};